export const filterConfigReportLic = {
  typeActivity: {
    title: 'Тип деятельности',
    options: [],
    searchPlaceholder: 'Найти тип деятельности',
  },
  typeDocument: {
    title: 'Тип документа',
    options: [],
    searchPlaceholder: 'Найти тип документа',
  },
  responsible: {
    title: 'Ответственный',
    searchPlaceholder: '',
    hasSearch: false,
  },
  statusLicanse: {
    title: 'Статус документа',
    options: [],
    hasSearch: false,
  },
};

export const initialFilterReportLic = {
  typeActivity: { selected: [], selectedIds: [], search: '' },
  typeDocument: { selected: [], selectedIds: [], search: '' },
  responsible: { selected: [], selectedIds: [], search: '' },
  statusLicanse: { selected: ['В процессе', 'Действующий', 'Просрочен'], selectedIds: [1, 2, 3] },
};

export const initialFilterOpenReportLic = {
  typeActivity: false,
  typeDocument: false,
  responsible: false,
  statusLicanse: false,
};
